// Generic renderer for structured tool outputs saved in the Content Vault.
// Recognises common shapes: strings, arrays of strings, arrays of dicts, nested dicts.

import React from "react";

const humanise = (k) => String(k).replace(/[_-]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

function renderValue(value, depth = 0) {
  if (value === null || value === undefined || value === "") {
    return <span className="text-[#94A3B8]">-</span>;
  }
  if (typeof value === "string") {
    return <div className="whitespace-pre-wrap leading-relaxed text-[15px] text-[#1F2937]">{value}</div>;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return <div className="text-[15px] text-[#1F2937]">{String(value)}</div>;
  }
  if (Array.isArray(value)) {
    if (value.length === 0) return <span className="text-[#94A3B8]">-</span>;
    if (value.every((v) => typeof v === "string" || typeof v === "number")) {
      return (
        <ul className="list-disc pl-5 space-y-1 text-[15px] text-[#1F2937]">
          {value.map((v, i) => (
            <li key={i} className="whitespace-pre-wrap">{String(v)}</li>
          ))}
        </ul>
      );
    }
    return (
      <div className="space-y-3">
        {value.map((v, i) => (
          <div key={i} className="border border-[#E2E8F0] rounded-md p-4 bg-[#F8FAFC]">
            {renderValue(v, depth + 1)}
          </div>
        ))}
      </div>
    );
  }
  if (typeof value === "object") {
    return (
      <div className="space-y-3">
        {Object.entries(value).map(([k, v]) => (
          <div key={k}>
            <div className="text-[11px] tracking-[0.18em] uppercase font-bold text-[#64748B] mb-1">{humanise(k)}</div>
            {renderValue(v, depth + 1)}
          </div>
        ))}
      </div>
    );
  }
  return <div className="text-[15px] text-[#1F2937]">{String(value)}</div>;
}

export function VaultOutputRenderer({ output }) {
  if (!output || (typeof output === "object" && !Array.isArray(output) && Object.keys(output).length === 0)) {
    return <div className="text-[#94A3B8] italic">No output stored.</div>;
  }
  if (typeof output === "string") {
    return <div className="whitespace-pre-wrap leading-relaxed text-[15px] text-[#1F2937]">{output}</div>;
  }
  if (Array.isArray(output)) return <div>{renderValue(output)}</div>;
  return (
    <div className="space-y-5">
      {Object.entries(output).map(([k, v]) => (
        <section key={k} className="dms-card p-5">
          <div className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#1D4E89] mb-3">{humanise(k)}</div>
          {renderValue(v)}
        </section>
      ))}
    </div>
  );
}

export default VaultOutputRenderer;
